import React from 'react';
import './Styles/Organize.scss';
import image from '../../../Assets/Cards/organizePhone.png';
import Tilt from 'react-parallax-tilt';

const Organize=()=>{
    return(
        <div className="organize-c">
            <div className="imgpart">
            <div className="img-small"></div>
            <div className="img-phone"></div>
           </div>
            <div className="content">
                <h1>Organize projects</h1>
                <p>Groups is a great way to keep your projects organised, so you can access projects most important to you without having to scroll your entire list.</p>
            </div>
        </div>
    )
};
export default Organize ;